import { useMutation } from 'react-query';

import { iFormPhoneValidationFields } from '@/components/Form/FormPhoneValidation';
import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

import { WRONG_TOKEN } from '..';
import { MobileToken } from '../types';

export type CreateMobileToken = {
  data: iFormPhoneValidationFields;
  groupId: string;
};

export const createMobileToken = ({ data, groupId }: CreateMobileToken): Promise<MobileToken> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'mobile-token/init/' + groupId;
  return axios
    .post(
      endPoint,
      { groupId: data.groupId, phone: data.phone, lang: data.lang },
      {
        validateStatus: (status) => status < 500,
      }
    )
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }

      if (response?.status === 406) {
        return {
          groupId: groupId,
          hasError: WRONG_TOKEN,
        };
      }

      return response;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};

type UseCreateMobileTokenOptions = {
  config?: MutationConfig<typeof createMobileToken>;
};

export const useCreateMobileToken = ({ config }: UseCreateMobileTokenOptions = {}) => {
  return useMutation({
    onMutate: async (creatingNotification: any) => {
      await queryClient.cancelQueries(['mobile-token', creatingNotification]);

      const previousDetails = queryClient.getQueryData<CreateMobileToken>([
        'mobile-token',
        creatingNotification,
      ]);

      queryClient.setQueryData(['mobile-token', creatingNotification], {
        ...previousDetails,
        ...creatingNotification.data,
      });

      return { previousDetails: previousDetails };
    },
    onError: (_, __, context: any) => {
      if (context?.previousDetails) {
        queryClient.setQueryData(
          ['mobile-token', context.previousDetails],
          context.previousDetails
        );
      }
    },
    onSuccess: (data) => {
      queryClient.refetchQueries(['mobile-token', data]);
    },
    ...config,
    mutationFn: createMobileToken,
  });
};
